import React from "react"; // Styles

import "./spinner.styles.scss";

function Spinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: "react__pdf--spinner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lds-dual-ring"
  }));
}

export default Spinner;